class MatrixOption {
	constructor() {
		this.text = '';
		this.translation = [];
	}
}

export default MatrixOption;
